"use client";

import { Button } from "@/components/ui/Button";

export default function GlobalError() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2">
      <h1 className="mt-4 font-semibold text-2xl">문제가 발생했습니다</h1>
      <p className="text-muted-foreground">
        죄송합니다. 예기치 않은 오류가 발생했습니다.
      </p>

      <Button className="mt-8" asChild>
        <a href="/school">홈으로 돌아가기</a>
      </Button>
    </div>
  );
}
